import type { AnyFieldApi } from "@tanstack/solid-form";
import { onMount, splitProps } from "solid-js";
import type { InputProps } from "@/components/ui/input";
import { Input } from "@/components/ui/input";
import { useCurrencyInputHelper } from "@/hooks/useCurrencyInputHelper";
import { cn } from "@/libs/cn";

export type CurrencyInputProps = InputProps & {
  fieldApi: AnyFieldApi;
  currency?: string;
};

export const CurrencyInput = (props: CurrencyInputProps) => {
  const [localProps, restProps] = splitProps<
    CurrencyInputProps,
    [readonly (keyof CurrencyInputProps)[]]
  >(props, ["fieldApi", "currency", "class", "classList"]);

  const currencyHandlers = useCurrencyInputHelper({
    fieldApi: localProps.fieldApi,
    currency: localProps.currency,
  });

  let inputRef: HTMLInputElement | undefined;

  onMount(() => {
    if (inputRef) {
      const hasValue = inputRef.value.trim() !== "";
      if (hasValue) {
        inputRef.dispatchEvent(
          new Event("blur", { bubbles: true, cancelable: true }),
        );
      }
    }
  });

  return (
    <Input
      {...restProps}
      {...currencyHandlers}
      class={cn(localProps.class)}
      classList={localProps.classList}
      ref={inputRef}
    />
  );
};
